import { render } from "./ProductSkuAsinItem.vue?vue&type=template&id=bb87b35c&scoped=true"
import script from "./ProductSkuAsinItem.vue?vue&type=script&lang=js"
export * from "./ProductSkuAsinItem.vue?vue&type=script&lang=js"

import "./ProductSkuAsinItem.vue?vue&type=style&index=0&id=bb87b35c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb87b35c"]])

export default __exports__